import { Component, computed, inject } from '@angular/core';

import { NzSpinModule } from 'ng-zorro-antd/spin';

import { I18nService } from '../../../../core/i18n/i18n.service';
import { LocaleService } from '../../../../core/i18n/locale.service';
import { ExportProgressService } from '../../export-progress.service';
import type { ExportPhase } from '../../models/export.types';

@Component({
  selector: 'app-export-progress-overlay',
  imports: [NzSpinModule],
  template: `
    @if (progress().active) {
      <div class="export-progress-overlay" role="status" aria-live="polite">
        <nz-spin nzSize="large" [nzTip]="phaseLabel()"></nz-spin>
      </div>
    }
  `,
  styles: `
    .export-progress-overlay {
      position: fixed;
      inset: 0;
      z-index: 2000;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(255, 255, 255, 0.72);
      backdrop-filter: blur(2px);
    }
  `,
})
export class ExportProgressOverlay {
  private readonly progressService = inject(ExportProgressService);
  private readonly i18n = inject(I18nService);
  private readonly locale = inject(LocaleService);

  readonly progress = this.progressService.progress;

  readonly phaseLabel = computed(() => {
    this.locale.locale();
    const phase = this.progress().phase;
    return phase ? this.labelForPhase(phase) : '';
  });

  private labelForPhase(phase: ExportPhase): string {
    const keys: Record<ExportPhase, string> = {
      resolving: 'common.export.progress.resolving',
      rendering: 'common.export.progress.rendering',
      saving: 'common.export.progress.saving',
      printing: 'common.export.progress.printing',
    };
    return this.i18n.t(keys[phase]);
  }
}
